import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { AlertType, Empresa, RetAPI, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { ThemeProvider, createTheme } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { MRT_ColumnDef, useMaterialReactTable, MaterialReactTable } from 'material-react-table'
import { useNavigate } from 'react-router-dom'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { EmpresaService } from '../../Pages/Empresas/EmpresaService'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import moment from 'moment'
import { Funcoes } from '../../Utils/Funcoes'
import { Tooltip } from 'react-tooltip'
import { FaTrashAlt } from 'react-icons/fa'
import { RiEdit2Fill } from 'react-icons/ri'

type Props = {
    empresa: Empresa[],
    handleUpdateEmpresaList: () => void,
}

type VisibilityState = Record<string, boolean>

interface RowData {
    id: number,
    razao: string,
    nome_fantasia: string,
    endereco: string,
    bairro: string,
    numero: string,
    cep: string,
    complemento: string,
    cidade: string,
    cnpj_cpf: string,
    ie_rg: string,
    cnae: string,
    regime_tributario: string,
    ativo: string,
    uf: string,
    dt_cadastro: string,
}

type TipoMap = {
    [key: string]: string
}

export const GridEmpresas = React.memo(({ empresa, handleUpdateEmpresaList }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_empresa")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_empresa") || '')
                : {
                    acao: true,
                    razao: true,
                    nome_fantasia: true,
                    cnpj_cpf: true,
                    ie_rg: false,
                    cnae: false,
                    regime_tributario: false,
                    ativo: false,
                    cep: false,
                    bairro: false,
                    numero: false,
                    complemento: false,
                    cidade: true,
                    uf: true,
                    dt_cadastro: false,
                }
        )
    }, [])

    const [idEmp, setIdEmp] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [empresas, setEmpresas] = useState<Empresa[]>([])
    const [nomeEmpresa, setNomeEmpresa] = useState("")

    let user = useSelector(state => selectUser(state))


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setEmpresas(empresa)
    }, [empresa])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_empresa", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await EmpresaService.Delete(idEmp, motivo, senha)
            Inputfocus()

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Empresa excluída com sucesso`)

                handleUpdateEmpresaList()

                //setEmpresas(await EmpresaService.Filter('', '', ''))
                //setModalShow(false)


            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
                //setModalShow(false)
            }

        } catch (error) {

            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir a empresa. Por favor, tente novamente`)
        }

    }, [idEmp])

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa_empresa")
        inputElement?.focus()
    }

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        
        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeEmpresa("")
        }
    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeEmpresa("")
    }, [])

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- CODIGO SEM USO --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    /*
   useEffect(() => {

       if (xJson) {

           if (json) {
               const newColumnVisibility: VisibilityState = { ...columnVisibility }
               newColumnVisibility.acao = json.acao
               newColumnVisibility.razao = json.razao
               newColumnVisibility.nome_fantasia = json.nome_fantasia
               newColumnVisibility.cnpj_cpf = json.cnpj_cpf
               newColumnVisibility.ie_rg = json.ie_rg
               newColumnVisibility.cnae = json.cnae
               newColumnVisibility.regime_tributario = json.regime_tributario
               newColumnVisibility.ativo = json.ativo
               newColumnVisibility.cep = json.cep
               newColumnVisibility.bairro = json.bairro
               newColumnVisibility.numero = json.numero
               newColumnVisibility.complemento = json.complemento
               newColumnVisibility.cidade = json.cidade
               newColumnVisibility.uf = json.uf
               newColumnVisibility.dt_cadastro = json.dt_cadastro

           }
       }

   }, [])
   */


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate();

    const navegarTelaEmpresaEdit = (id: number) => {
        navigate(`/companies/edit/${id}`);
    }

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const tipoAtivoMap: TipoMap = {
        'S': 'Sim',
        'N': 'Não',
    }

    function mapTipoAtivo(ativo: string) {
        return (

            <>
                {tipoAtivoMap[ativo] || <div className='text-red-400'>N/D</div>}
            </>

        )
    }

    const tipoRegTribMap: TipoMap = {
        'LR': 'Lucro Real',
        'LP': 'Lucro Presumido',
        'SN': 'Simples Nacional'
    }

    function mapTipoRegTrib(regime_tributario: string) {
        return (
            <>
                {tipoRegTribMap[regime_tributario] || <div className='text-red-400'>N/D</div>}
            </>

        )
    }

    const colunas = useMemo<MRT_ColumnDef<Empresa>[]>(
        () => [

            {
                accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: true, size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    const navegar = () => {
                        navegarTelaEmpresaEdit(rowData.id)
                    }

                    const handleExcluirClick = () => {

                        const timerExcluir = setTimeout(() => {
                            setIdEmp(rowData.id)
                            setNomeEmpresa(rowData.razao)
                            setModalShow(true)
    
                            let divPerfil = document.getElementById('div-perfil') as HTMLDivElement
    
                            if (divPerfil) {
                                divPerfil.classList.add('hidden')
                            }
    
                            let menuFiltro = document.getElementById("divMenuFiltroEmp") as HTMLDivElement
                            let menuInputs = document.getElementById("divInputsEmp") as HTMLDivElement
    
                            if (menuFiltro) {
    
                                menuInputs.classList.add("invisible")
    
                                const timer = setTimeout(() => {
                                    menuFiltro.classList.remove("max-h-[390px]")
                                    menuFiltro.classList.add("max-h-[0px]")
                                    Inputfocus()
                                    clearTimeout(timer)
                                }, 100)
                            }

                            clearTimeout(timerExcluir)
                        }, 0);
                        
                    }

                    return (
                        <div className={`flex justify-start w-full`}>

                            <button
                                onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                          bg-sky-500`}>
                                <RiEdit2Fill size="20px" />
                                <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                    <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                                </Tooltip>
                            </button>

                            <button
                                onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                          bg-red-500 ml-2`} >
                                <FaTrashAlt size="18px" />
                                <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed"  >
                                    <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                                </Tooltip>
                            </button>

                        </div>
                    )
                }

            },

            {
                accessorKey: 'razao', visibleInShowHideMenu: true, header: 'Razão Social', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.razao ? rowData.razao : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'nome_fantasia', visibleInShowHideMenu: true, header: 'Nome Fantasia', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.nome_fantasia ? rowData.nome_fantasia : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'cnpj_cpf', visibleInShowHideMenu: true, header: 'CNPJ', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.cnpj_cpf ? Funcoes.FormatDoc(rowData.cnpj_cpf.toString()) : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'ie_rg', visibleInShowHideMenu: true, header: 'Insc. Estadual', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.ie_rg ? rowData.ie_rg : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'cnae', visibleInShowHideMenu: true, header: 'CNAE', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.cnae ? rowData.cnae : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'regime_tributario', visibleInShowHideMenu: true, header: 'Regime Tributario', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {
                    const rowData = cell.row.original as RowData
                    const tipoReg: string = rowData.regime_tributario

                    return mapTipoRegTrib(tipoReg)
                }
            },

            {
                accessorKey: 'ativo', visibleInShowHideMenu: true, header: 'Ativo', size: 100, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

                Cell: (cell: any) => {
                    const rowData = cell.row.original as RowData
                    const tipoAtivo: string = rowData.ativo

                    return mapTipoAtivo(tipoAtivo)
                }
            },

            {
                accessorKey: 'cep', visibleInShowHideMenu: true, header: 'CEP', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.cep ? Funcoes.FormatCep(rowData.cep.toString()) : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'endereco', visibleInShowHideMenu: true, header: 'Logradouro', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.endereco ? rowData.endereco : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'bairro', visibleInShowHideMenu: true, header: 'Bairro', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.bairro ? rowData.bairro : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'numero', visibleInShowHideMenu: true, header: 'Número', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.numero ? rowData.numero : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'complemento', visibleInShowHideMenu: true, header: 'Complemento', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.complemento ? rowData.complemento : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'cidade', visibleInShowHideMenu: true, header: 'Cidade', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.cidade ? rowData.cidade : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'uf', visibleInShowHideMenu: true, header: 'Estado', size: 200, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.uf ? rowData.uf : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'dt_cadastro', visibleInShowHideMenu: true, header: 'Data de Cadastro', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.dt_cadastro ? moment(rowData.dt_cadastro).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

        ], [])


    const table = useMaterialReactTable({
        columns: colunas,
        data: empresas,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,
        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: true,
        enableColumnFilters: false,
        enableHiding: true,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir a empresa - ${nomeEmpresa || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>

    )
})